import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";

// Source of a candidate field's current value → badge label + color. Visually distinct from the
// enrichment-phase badges (see _Shared/enrichment.js) so the two systems don't read as one.
// "manual" is the trusted/hand-verified source (green); the rest are machine-sourced.
const SOURCE_CONFIG = {
  manual: { color: "green", tKey: "source_manual" },
  cv: { color: "teal", tKey: "source_cv" },
  linkedin: { color: "blue", tKey: "source_linkedin" },
  crmNotes: { color: "violet", tKey: "source_crmNotes" },
  import: { color: "gray", tKey: "source_import" },
};

/**
 * Small badge showing where a field's current value came from ([CV] / [LinkedIn] / [Manual] / …).
 * Renders nothing for an unknown/absent source kind (so legacy fields with no provenance stay clean).
 */
export default function ProvenanceBadge({ sourceKind, size = "xs" }) {
  const { t } = useTranslation("Veft");
  const cfg = SOURCE_CONFIG[sourceKind];
  if (!cfg) return null;
  return <Badge size={size} variant="light" color={cfg.color}>{t(cfg.tKey)}</Badge>;
}
